import useSingleTrackingEvent from "@Events/hooks/useSingleTrackingEvent";
import StsPageDatePickerClickEventModel from "@Events/models/StsPageDatePickerClickEventModel";

export default function useStsPageDatePickerClickEvent(action: string) {
    return useSingleTrackingEvent("trip_landing_page_search_results_redirect", StsPageDatePickerClickEventModel(action))
}